export default __webpack_public_path__ + "static/media/feed.1222f412.svg";